import {
	gridGutter,
	gridGutter1q1dot5,
	gridGutter1q4
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

export const loadingStyle = `
	display: flex;
	justify-content: center;
	padding: 64px 0;
	width: 100%;
`;

export const defaultStyle = `
  .edit-credit-card-details {
    padding: ${gridGutter1q4}px ${gridGutter}px;
    h6 {
      margin-bottom: ${gridGutter}px;
    }
    .form-group {
      margin-bottom: ${gridGutter1q1dot5}px;
    }
  }
`;
